export type LatLng = {
    latitude: number;
    longitude: number;
};

export function humanizeDistance(
    pointA: LatLng,
    pointB: LatLng,
    locale = "en-US",
    unitSystem = "metric"
) {
    const toRad = (degree: number) => (degree * Math.PI) / 180;

    const deltaLatitude = toRad(pointA.latitude - pointB.latitude);
    const deltaLongitude = toRad(pointA.longitude - pointB.longitude);

    const a =
        Math.pow(Math.sin(deltaLatitude / 2), 2) +
        Math.pow(Math.sin(deltaLongitude / 2), 2) *
            Math.cos(toRad(pointA.latitude)) *
            Math.cos(toRad(pointB.latitude));

    const hav = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const result =
        unitSystem === "metric"
            ? {
                  distance: hav * 6373,
                  unit: "km",
                  smallUnit: "m",
                  factor: 1000,
                  smallBorder: 0.9,
                  largeBorder: 200,
              }
            : {
                  distance: hav * 3960,
                  unit: "mi",
                  smallUnit: "yd",
                  factor: 1760,
                  smallBorder: 0.5,
                  largeBorder: 300,
              };

    const formatter = new Intl.NumberFormat(locale, { maximumSignificantDigits: 2 });
    if (result.distance < result.smallBorder) {
        let distance = result.distance * result.factor;
        if (distance < 40) return `< 50 ${result.smallUnit}`;

        distance = Math.round(distance / 50) * 50;
        return `${formatter.format(distance)} ${result.smallUnit}`;
    } else if (result.distance > result.largeBorder) {
        return `>${formatter.format(result.largeBorder)} ${result.unit}`;
    }

    return `${formatter.format(result.distance)} ${result.unit}`;
}
